export const STATUS_ACTIVE = 1;
export const STATUS_PAUSED = 2;
import { prompt } from '@/components/PromptDialog/sagas';
import i18n from '@/i18n';

const { t } = i18n; // Updated by script

export function isPaused(model) {
  return model.status === STATUS_PAUSED;
}

export function isActive(model) {
  return model.status === STATUS_ACTIVE;
}

export function* promptRestoreActivity(modelName, model) {
  if (!model.previousActivity || model.previousActivity.length === 0) {
    return false;
  }

  return yield prompt(`${t('restore-activity')} ${t(`${modelName}`)}?`, {
    yesLabel: t('restore-all-activity'),
    noLabel: t('restore-dont-restore'),
  });
}
